import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import "@/styles/report-print.css";
import App from "@/App";
import { AudienceProvider } from "@/contexts/AudienceContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AudienceProvider>
          <App />
        </AudienceProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
